import React, {useState, useEffect} from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container,  Grid, Button} from '@mui/material'
import {GasCountryService} from '../shared/service';
//import SearchIcon from "@mui/icons-material/Search";
import CustomDataGrid from '../../../customUtil/DataGrid';
const columns = [
    {
        field: 'countryName', headerName: 'Name', width: 250,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/gas/country/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {
        field: 'countryCode', headerName: 'Code', width: 100
    },
    {
        field: 'focalPointCount', headerName: 'Focal Points', width: 150
    },
    {
        field: 'prsPrimaryContact', headerName: 'Primary PRS', width: 250
    },
    {
        field: 'alternateNames', headerName: 'Other Spellings', width: 250

    }

]

const GasCountries = () => {
        const [list, setList] = useState([]);
        const [result, setResult] = useState({});
      
        const history = useHistory();
    

        useEffect(() => {
            GasCountryService.search()
                .then((response) => {
                    setResult(response.data);
                });
        }, []);

        useEffect(() => {
            if (result.results) {
                setList(result.results);
            }else{
                setList([]);
            }
        }, [result]);

        return (
            <Container>
                <header>
                    <h1>Countries</h1>
                </header>
                    <Grid container spacing={5}>
                     
                        <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/gas/country/new')}}>Create New</Button>
                        </Grid> 
                        {/* <Grid item xs={12}>
                            <Controller
                                name="searchTerm"
                                control={methods.control}
                                fullWidth
                                onChange={(v) => onSearchTermChanged(v)}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (<TextField fullWidth
                                                 onBlur={onBlur}
                                                 onChange={(e) => {
                                                     onChange(e.target.value);
                                                     onSearchTermChanged(e.target.value)
                                                 }}
                                                 label="Search: Type country name, country code, PRS focal point"
                                                 startAdornment={
                                                     <InputAdornment position="start">
                                                         <SearchIcon/>
                                                     </InputAdornment>
                                                 }
                                />)}
                                label="Search: Type country, country code, PRS focal point"
                                color="primary"
                            />
                        </Grid> */}
                        <Grid item xs={12}>                         
                                <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                />
                        </Grid>
                    </Grid>
                
            </Container>
        );
    }
;

export default GasCountries;
